import * as React from "react";
import { forwardRef } from "react";

import { cn } from "@lab/src/lib/util";
import { Input, InputProps } from "./input";

export interface IconInputProps extends InputProps {
	/** Leading icon, vertically centered at the left edge of the input. */
	icon?: React.ReactNode;
	/**
	 * Trailing adornment (e.g. clear button or shortcut hint) at the right
	 * edge. Interactive content must opt back in with pointer-events-auto.
	 */
	trailing?: React.ReactNode;
	/** Class for the outer wrapper; className styles the input itself. */
	containerClassName?: string;
}

export const IconInput = forwardRef<HTMLInputElement, IconInputProps>(
	({ icon, trailing, className, containerClassName, ...props }, ref) => {
		return (
			<div className={cn("relative", containerClassName)}>
				{icon && (
					<div className="pointer-events-none absolute left-3 top-1/2 flex -translate-y-1/2 items-center text-muted-foreground [&_svg]:h-4 [&_svg]:w-4">
						{icon}
					</div>
				)}
				<Input
					ref={ref}
					className={cn(icon && "pl-10", trailing && "pr-10", className)}
					{...props}
				/>
				{trailing && (
					<div className="pointer-events-none absolute right-3 top-1/2 flex -translate-y-1/2 items-center">
						{trailing}
					</div>
				)}
			</div>
		);
	}
);
IconInput.displayName = "IconInput";
